import axios from 'axios';

class BlogListingsGrid {
  constructor(component) {
    this.refs = {
      loadMore: '.js-load-more',
      gridInner: '.js-blog-posts-grid-inner',
      post: '.js-post',
    };
    
    this.dom = {
      $component: component,
      $loadMore: component.querySelector(this.refs.loadMore),
      $gridInner: component.querySelector(this.refs.gridInner),
      $posts: component.querySelectorAll(this.refs.post),
    };
    
    this.state = {
      currentPage: 1,
      maxPage: parseInt(blog_params.max_page, 10),
      featuredPostId: component.dataset.featuredPostId || null,
    };

    this.mount();

    this.init();
  }

  mount() {
    const { dom } = this;

    if (dom.$loadMore) {
      dom.$loadMore.addEventListener('click', this.handleLoadMoreClick.bind(this));
    }

    if (dom.$posts.length) {
      this.setPostClickListeners(dom.$posts);
    }
  }

  init() {
    const { dom, state } = this;

    this.updateLoadMoreVisibility();

    this.hideFeaturedPost();
  }

  hideFeaturedPost() {
    const { dom, state } = this;
    if (!state.featuredPostId) return;

    const $featuredPost = dom.$gridInner.querySelector(`[data-post-id="${state.featuredPostId}"]`);
    if ($featuredPost) {
      $featuredPost.style.display = 'none';
    }
  }

  setPostClickListeners($posts) {
    $posts.forEach($post => {
      $post.addEventListener('click', this.handlePostClick.bind(this));
    });
  }

  handlePostClick(e) {
    const $post = e.currentTarget;
    const { href } = $post.dataset

    if (href) {
      window.location = href;
    }
  }

  async handleLoadMoreClick(e) {
    const { dom, state } = this;
    e.preventDefault();
    e.stopPropagation();
    dom.$loadMore.disabled = true;

    try {
      const formData = new URLSearchParams();
      formData.append('action', 'load_more_posts');
      formData.append('security', blog_params.security);
      formData.append('page', state.currentPage + 1);
      formData.append('featured_post_id', state.featuredPostId);

      const response = await axios({
        method: 'post',
        url: blog_params.ajaxurl,
        data: formData,
      });

      if (response.status === 200) {
        state.currentPage += 1;
        const postsHTML = response.data;

        // Append the new posts to the grid
        dom.$gridInner.insertAdjacentHTML('beforeend', postsHTML);

        // check for featured post and hide it if necessary
        this.hideFeaturedPost();

        // Set click listeners on the new posts
        const newPosts = dom.$gridInner.querySelectorAll(this.refs.post);
        this.setPostClickListeners(newPosts);

        // focus on first CTA in the new posts for accessibility
        newPosts[newPosts.length - 6].querySelector('a')?.focus();

        // Update Load More button visibility
        this.updateLoadMoreVisibility();

        return response;
      }

      throw new Error('loadMore did not respond with status 200');
    } catch (err) {
      console.error('loadMore error: ', err);
      throw new Error(err);
    }
  }

  updateLoadMoreVisibility() {
    const { dom, state } = this;

    if (state.currentPage >= state.maxPage && dom.$loadMore) {
      dom.$loadMore.remove();
      return;
    } 
    
    if (dom.$loadMore) {
      dom.$loadMore.disabled = false;
    }
  }
}

const $blogListingsGrid = document.querySelector('.js-blog-listings-grid');
if ($blogListingsGrid) new BlogListingsGrid($blogListingsGrid);